<script>
  import BetBuilderMarket from './betbuilder-market';

  export default {
    name: 'BetBuilderTab',
    functional: true,
    components: { BetBuilderMarket },
    props: {
      tab: {
        type: Object,
        reqired: true,
      },
      fixture: {
        type: Object,
        reqired: true,
      },
      tabIdx: {
        type: Number,
      }
    },
    render(h, { props }) {
      return [
        ...props.tab.markets.map((market, idx) => <BetBuilderMarket key={`${props.tabIdx}_${idx}`} market={market} fixture={props.fixture} />)
      ];
    },
  };
</script>
